import React, { useState } from "react";
import styled from "styled-components";
import { InformationCircleIcon } from "@heroicons/react/outline";

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
`;
const Content = styled.div`
  width: 230px;
  position: absolute;
  border-radius: 5px;
  left: calc(100% + 6px);
  top: 50%;
  transform: translateX(0) translateY(-50%);
  padding: 7px;
  color: #f9f8f8;
  background: #1c3a58;
  font-size: 14px;
  z-index: 100;

  @media screen and (max-width: 500px) {
    width: 100px;
    font-size: 12px;
  }

  &::before {
    content: " ";
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: 6px;
    margin-left: -6px;
    left: -6px;
    top: 50%;
    transform: translateX(0) translateY(-50%);
    border-right-color: #1c3a58;
  }
`;

const Icon = styled.span`
  margin-left: 5px;
  padding: auto;
  z-index: 3;
  display: inline-block;

  &:hover {
    * {
      color: #042547;
    }
  }
`;

function Tooltip({ content, id }) {
  const [active, setActive] = useState(false);

  const showTip = () => {
    setActive(true);
  };

  const hideTip = () => {
    setActive(false);
  };

  return (
    <Wrapper onMouseEnter={showTip} onMouseLeave={hideTip} id={id}>
      <Icon>
        <InformationCircleIcon
          style={{
            width: "18px",
            height: "18px",
            marginBottom: "-4px",
            color: "#c0c5cb",
          }}
        />
      </Icon>
      {active && <Content>{content}</Content>}
    </Wrapper>
  );
}

export default Tooltip;
